export const Type02 = 'ListenAndRepeat';
export const Type03 = 'OneCorrectQuestionText'; //??
export const Type05 = 'OneTextMultiOptionOneCorrect';
export const Type07 = 'RepeatTheWords';
export const Type12 = 'RepeatTheSentence';
export const Type13 = 'ScrambleWord';
export const Type14 = 'MakeASentence';
export const Type15 = 'MatchingWordWithPicture';
export const Type18 = 'CompleteWord';
export const Type20 = 'Grammar';